type PageLayoutContentProps = { children: React.ReactNode; className?: string }
export function PageLayoutCustomContent({ children, className }: Readonly<PageLayoutContentProps>) {
  return (
    <div className={'PageLayoutContent ' + className}>
      <div className="PageLayoutContent__content">{children}</div>
    </div>
  )
}
